module.exports = __webpack_public_path__ + "img/euler.1376096e.png";